// extracted by mini-css-extract-plugin
export var box = "_7z-1";
export var checked = "_7z-2";
export var descriptionSpacer = "_7z-9";
export var disabled = "_7z-3";
export var icon = "_7z-6";
export var input = "_7z-0";
export var labelSpacer = "_7z-8";
export var medium = "_7z-5";
export var small = "_7z-4";
export var text = "_7z-7";